import { useState, useCallback } from "react";
import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";
import { ExpenseManagementService } from "Services/EmployeeServices/ExpenseManagementService";

const useExpenseManagement = () => {
  const [expenseList, setExpenseList] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchExpenseList = useCallback(async () => {
    try {
      setLoading(true);
      const data = await ExpenseManagementService.fetchExpenseList();
      setExpenseList(Array.isArray(data) ? data : []); // ensure array
    } catch (error) {
      console.error("❌ Error fetching expenses:", error);
      setExpenseList([]); // Set to empty array on error
    } finally {
      setLoading(false);
    }
  }, []);

  // Update status API call
  const updateExpenseStatus = useCallback(async (expenseManagementId, status) => {
    try {
      const payload = {
        expenseManagementId,
        status,
      };
      const response = await axiosInstance.post(API.expenseManagement.updateStatus, payload);
      return response.data;
    } catch (error) {
      console.error("❌ Error updating expense status:", error);
      throw error;
    }
  }, []);

  return {
    expenseList,
    loading,
    fetchExpenseList,
    updateExpenseStatus,
  };
};

export default useExpenseManagement;